import Vue from 'vue'
import store from '~/js/store'
import textField from '~/pug/blocks/field/field.vue'
import fileField from '~/pug/blocks/field/file.vue'
import textareaField from '~/pug/blocks/field/textarea.vue'
import sendform from './sendform.js'
import validate from './validate.js'

const plainform = {
  data() {
    return {
      errors: [],
      isSuccess: false,
      isValid: false,
    }
  },
  components: {
    textField, fileField, textareaField
  },
  computed: {
    title () {
      return store.state.plainform.title
    },
    sendText () {
      return store.state.plainform.submitText
    },
    successText () {
      return store.state.plainform.successText
    },
    fields () {
      let fields

      fields = store.state.plainform.fields.map(function(field) {
        return field
      })

      return fields
    },
    updateField: {
      get: function(test) {
        console.log(test)
      },
      set: function(newField) {
        store.commit('changeFieldP', newField);
      }
    }
  },
  methods: {
    closeModal() {
      store.commit('plainformHide');
    },
    formSubmit(e) {
      let result
      let fields
      let isValid

      isValid = true;

      fields = store.state.plainform.fields.map(function(field) {
        field = validate(field)
        if (field.error === true) {
          isValid = false
        }
        return field
      })

      store.commit('validateFieldsP', fields);

      if (isValid === true) {
        result = sendform(store.state.plainform)
        result.then(response => {
          if (response.data.success === true) {
            this.isSuccess = true
          }
        })
      }
    },
    getComponentByType(type) {
      return type + 'Field'
    }
  }
}

export default plainform
